import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  List,
  ListItem,
  ListItemAvatar,
  Typography,
} from "@material-ui/core";
import "./index.css";
import AvatarIcon from "./Icons/avatar";
const useStyles = makeStyles({
  avatar: {
    textAlign: "center",
    alignItems: "center",
    position: "absolute",
    paddingInlineStart: "27px",
    marginTop: "30px",
  },
  dialogTital: {
    fontSize: "0.8rem",
    textAlign: "center",
    paddingTop: "20px",
    color: "#686D88",
  },
  titleWords: {
    fontSize: "1rem",
    textAlign: "center",
    width: "90%",
    paddingTop: "70px",
    paddingInlineStart: "38px",
    color: "#686D88",
  },
  callButton: {
    insetInlineStart: "100px",
    marginTop: "10px",
    marginBottom: "25px",
    backgroundColor: "green",
    color: "white",
    textTransform: "capitalize",
    height: "35px",
    width: "132px",
  },
  disconnectButton: {
    insetInlineStart: "100px",
    marginTop: "25px",
    marginBottom: "12px",
    backgroundColor: "#FF3B30",
    color: "white",
    textTransform: "capitalize",
    height: "35px",
    width: "132px",
  },
});

export default function SimpleDialog(props) {
  const classes = useStyles();

  return (
    <>
    <div id="myModal" style={{ display: "none" }}>
      <div id="myModal-content">
        <List>
          <Typography className={classes.dialogTital}>Connecting...</Typography>
          <ListItem>
            <ListItemAvatar className={classes.avatar}>
              <AvatarIcon />
            </ListItemAvatar>
          </ListItem>
          <Typography className={classes.titleWords}>
           You have a Call
          </Typography>
          <Button
            name="rejectCall"
            id="rejectCall"
            variant="contained"
            className={classes.disconnectButton}
          >
            Disconnect
          </Button>
          <br />
          <Button
            name="answerCall"
            id="answerCall"
            variant="contained"
            className={classes.callButton}
          >
            Connect
          </Button>
        </List>
      </div>
    </div>
    </>
  );
}
